var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlackSmTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "#191713"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4381_1387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33088 17.8498C14.7635 17.8498 17.7358 13.3479 17.7358 9.44497C17.7358 9.31841 17.7329 9.18903 17.7273 9.06247C18.3055 8.64433 18.8045 8.12641 19.2008 7.53303C18.6623 7.77261 18.0906 7.92908 17.5051 7.9971C18.1216 7.6276 18.5831 7.04714 18.8042 6.36331C18.2243 6.70699 17.5901 6.94942 16.9288 7.08022C16.4833 6.60679 15.8942 6.29332 15.2526 6.18828C14.611 6.08324 13.9527 6.19248 13.3794 6.49911C12.8062 6.80574 12.3499 7.29268 12.0811 7.88464C11.8123 8.4766 11.746 9.14062 11.8925 9.77403C10.7183 9.71511 9.56954 9.41008 8.52077 8.87871C7.472 8.34735 6.5466 7.60152 5.80456 6.68956C5.42742 7.3398 5.31202 8.10924 5.4818 8.84151C5.65158 9.57378 6.09382 10.2139 6.71863 10.6318C6.24956 10.617 5.79077 10.4907 5.38016 10.2634V10.3C5.37974 10.9823 5.61564 11.6438 6.04777 12.1719C6.47989 12.7 7.08158 13.0622 7.75053 13.1968C7.31601 13.3157 6.85997 13.3331 6.41769 13.2475C6.60645 13.8343 6.97373 14.3476 7.46824 14.7157C7.96276 15.0837 8.55985 15.2882 9.17619 15.3006C8.12984 16.1225 6.83729 16.5683 5.50672 16.5662C5.27075 16.5659 5.03502 16.5514 4.80078 16.5229C6.1525 17.3901 7.7249 17.8507 9.33088 17.8498Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4381_1387"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.4,
    height: 14.4,
    fill: "white",
    transform: "translate(4.80078 4.7998)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackSmTwitter);
export default __webpack_public_path__ + "static/media/black-sm-twitter.7b904dbcdfd6ec87a265aa73ebfc2a3a.svg";
export { ForwardRef as ReactComponent };